<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-20 11:10:35
-->
<template>
  <div class="infoCell">
      <div class="left">
          <yx-avatar :src="row.avatar_url"></yx-avatar>
      </div>
      <div class="right ml-10">
          <p class="yx-color-text-primary fz-14">{{ row.nick_name }}</p>
      </div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin],
  components: {
    
  }
}
</script>
<style lang="less" scoped>
.infoCell{
    display: flex;
    align-items: center;
}
</style>